import * as React from 'react'
import { Box } from "@mui/material"

import { SkuInfoBlock, ImageSkuBlock } from "@components"
import { useBuildExternalURL } from "@hooks"


export default function skuColumn() {
	return [{
		name: 'ean', label: 'Ean',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'Product Name',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'skuName', label: 'Product Name',
		options: {
			filter:false,
			headerAlign: 'center',
			customBodyRowRenderLite: (value, { category, brand, ean, skuID }) => {
				const { imageURL } = useBuildExternalURL({ imageData: { skuID } })
				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
				<Box>
					<ImageSkuBlock imageURL={imageURL} />
				</Box>
				<Box>
					<SkuInfoBlock 
						sku={value} 
						category={category} 
						brand={brand} 
						ean={ean}
					/>
				</Box>
			</Box>}
		}
	}]
}
